"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var Option = antd_1.Select.Option;
/**
 * Combobox offering the attributes to be filtered on.
 */
var AttributeCombo = /** @class */ (function (_super) {
    __extends(AttributeCombo, _super);
    function AttributeCombo(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.value
        };
        return _this;
    }
    AttributeCombo.getDerivedStateFromProps = function (nextProps, prevState) {
        return {
            value: nextProps.value
        };
    };
    AttributeCombo.prototype.render = function () {
        var _this = this;
        var _a = this.props, internalDataDef = _a.internalDataDef, onAttributeChange = _a.onAttributeChange, label = _a.label, placeholder = _a.placeholder, attributeNameFilter = _a.attributeNameFilter, hideAttributeType = _a.hideAttributeType;
        var options = [];
        if (internalDataDef) {
            var attrDefs_1 = internalDataDef.schema.properties;
            // create sth like ['foo', 'bar', 'kalle'];
            var attrNames = [];
            for (var key in attrDefs_1) {
                if (attrDefs_1.hasOwnProperty(key)) {
                    attrNames.push(key);
                }
            }
            // create an option per attribute
            options = attrNames.filter(attributeNameFilter).map(function (attrName) {
                var attrNameMapped = _this.props.attributeNameMappingFunction(attrName);
                return (React.createElement(Option, { key: attrName, value: attrName }, hideAttributeType ? attrNameMapped : attrNameMapped + " (" + attrDefs_1[attrName].type + ")"));
            });
        }
        var helpTxt = this.props.validateStatus !== 'success' ? this.props.help : null;
        return (React.createElement("div", { className: "gs-attr-combo" },
            React.createElement(antd_1.Form.Item, { label: label, colon: false, validateStatus: this.props.validateStatus, help: helpTxt }, internalDataDef ?
                React.createElement(antd_1.Select, { value: this.state.value, style: { width: '100%' }, onChange: onAttributeChange, placeholder: placeholder }, options)
                :
                    React.createElement(antd_1.Input, { draggable: true, onDragStart: function (e) { return e.preventDefault(); }, value: this.state.value, placeholder: placeholder, style: { width: '100%' }, onChange: function (event) {
                            onAttributeChange(event.target.value);
                        } }))));
    };
    AttributeCombo.defaultProps = {
        label: 'Attribute',
        placeholder: 'Select Attribute',
        value: undefined,
        hideAttributeType: false,
        attributeNameFilter: function () { return true; },
        attributeNameMappingFunction: function (n) { return n; },
        validateStatus: 'success',
        help: 'Please select an attribute.'
    };
    return AttributeCombo;
}(React.Component));
exports.AttributeCombo = AttributeCombo;
exports.default = AttributeCombo;
//# sourceMappingURL=AttributeCombo.js.map